module.exports = __webpack_public_path__ + "img/微信图片_20251007143222_2271_2.8af28c53.jpg";